import { UserProfile } from '@chr/online-shared-microsite-core';
import { Action } from 'redux';

export enum ActionTypes {
  FEATURE_FLAGS_INIT = 'FEATURE_FLAGS_INIT',
  FEATURE_FLAGS_SET = 'FEATURE_FLAGS_SET',
  FEATURE_FLAGS_RETRIEVAL_FAILED = 'FEATURE_FLAGS_RETRIEVAL_FAILED',
}

export interface IAction<Payload = {}> extends Action<ActionTypes> {
  payload?: Payload;
}

export enum Status {
  None = 'None',
  Loading = 'Loading',
  Successful = 'Successful',
  Failed = 'Failed',
}

export const featureFlagNames = {
};

export interface FeatureFlags {
  [featureFlagName: string]: boolean;
}

export type IFeatureFlagsGetAction = IAction<UserProfile>;
export type IFeatureFlagsSetAction = IAction<FeatureFlags>;

export type IFeatureFlagsAction = IFeatureFlagsGetAction | IFeatureFlagsSetAction;
